import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sourcingUrl } from "@findemdev/findem-helpers";
import type { IOrgV2 } from "../types/orgs";

export const orgsApi = createApi({
  reducerPath: "orgsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: sourcingUrl,
    credentials: "include",
  }),
  endpoints: (build) => ({
    getOrgs: build.query<IOrgV2[], { joid: string }>({
      query: ({ joid }) => ({
        url: `/api/orgs/v2?joid=${encodeURIComponent(joid)}`,
        credentials: "include",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetOrgsQuery } = orgsApi;
